// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"358":"c7e36581","403":"2bdc15da","629":"3c99ad5f","828":"6cc522b3","917":"d6da24ba"}[chunkId] + ".chunk.js";
};